module.exports = __webpack_public_path__ + "img/blank_img.c9a0c220.png";